module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Hire purchase info"},"et":{"title":"Hire purchase info"},"ru":{"title":"Hire purchase info"}}')
  delete Component.options._Ctor
}
